var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"companies-container"},[(_vm.loading)?_c('div',{staticClass:"circle-progress"}):_c('company-detail',{attrs:{"company":_vm.company,"preview":false},on:{"company-section-viewed":_vm.sectionViewed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }